import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["menuItemGroup", "menuItemGroupWrap"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    menuitemgroup,
    wrap,
    menuItemGroupStyles
  } = _ref;
  let cssRoot = {};

  const {
    menuItemGroup,
    menuItemGroupWrap
  } = menuItemGroupStyles,
        otherStyles = _objectWithoutProperties(menuItemGroupStyles, _excluded);

  if (menuitemgroup) {
    const menuItemGroupCSS = _objectSpread(_objectSpread({}, menuItemGroup), otherStyles);

    cssRoot = safeMerge(menuitemgroup.root, menuItemGroupCSS);

    if (wrap) {
      cssRoot = safeMerge(cssRoot, menuItemGroupWrap);
    }
  }

  return {
    cssRoot
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    wrap,
    menuItemGroupStyles
  } = _ref2;
  const menuitemgroup = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.menuitemgroup;
  return setTheme({
    menuitemgroup,
    wrap,
    menuItemGroupStyles
  });
}